/** Non-breaking space regex for normalizing text from CMS/API responses. */
export const NBSP = /\u00A0/g

/** Collapses multiple whitespace characters into a single space. */
export const WHITESPACE = /\s+/gu

/** Matches zero or more digit-only characters (used for numeric input validation). */
export const DIGITS_ONLY = /^\d*$/u

/** Validates ISO 4217 currency codes (exactly 3 uppercase letters). */
export const CURRENCY_CODE = /^[A-Z]{3}$/u

/** Splits variant titles on " / " (space-padded slash) to preserve compound sizes like "S/M". */
export const SIZE_DELIMITER = /\s+\/\s+/u

/** Fallback delimiter: splits on "/" with optional whitespace (for titles like "Navy/XS"). */
export const SIZE_DELIMITER_FALLBACK = /\s*\/\s*/u

/** Recognized "one size" labels — sorted first in size comparisons. */
export const ONE_SIZE_KEYS = new Set(['ONE SIZE', 'ONE SIZE FITS ALL', 'OS', 'OSFA'])
